import script from "./Statistics.vue?vue&type=script&setup=true&lang=js"
export * from "./Statistics.vue?vue&type=script&setup=true&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=c11e6a80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c11e6a80"]])

export default __exports__